<script lang="ts">
	import { _ } from 'svelte-i18n';
	import Icon from '$lib/components/Icon/Icon.svelte';

	export let onClose: () => void;
	export let hasAIResponseError = false;
	export let isJwtExpired = false;
</script>

<div class="modal-header">
	<div class="title-container">
		<h1 class="modal-title">
			<img src="/_static/AI/info_icon.svg" alt={$_('hubs.copywriter.title')} />
			{$_('hubs.copywriter.title')}
			<div class="betaPill">BETA</div>
		</h1>
	</div>
	<button class="close-button" on:click={onClose} type="button">
		<Icon icon="close" size="24" />
	</button>
</div>
{#if hasAIResponseError}
	<div
		class="error-message-box"
		style:border="1px solid #e52b20"
		style:background-color="#fef2f2"
		role="alert">
		<img src="/_static/AI/error_icon.svg" alt="error" width="24" height="24" />
		<p class="error-message-text">
			{$_('hubs.copywriter.errors.response_error')}
		</p>
	</div>
{/if}
{#if isJwtExpired}
	<div
		class="error-message-box"
		style:border="1px solid var(--warningColor)"
		style:background-color="#fffae7"
		role="alert">
		<img src="/_static/AI/warning_icon.svg" alt="warning" width="24" height="24" />
		<p class="error-message-text">
			{$_('hubs.copywriter.errors.jwt_expired')}
		</p>
	</div>
{/if}
<div class="horizontal-divider" />

<style>
	.modal-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.title-container {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.modal-title {
		display: flex;
		align-items: center;
		margin: 0;
		color: #333;
		font-size: 20px;
		font-weight: 600;
		gap: 8px;
	}

	.betaPill {
		display: flex;
		align-items: center;
		padding-block: 4px;
		padding-inline: 6px;
		border-radius: 20px;
		background-color: var(--alidaUIPrimary);
		color: white;
		font-size: 8px;
		font-weight: bold;
		text-transform: uppercase;
	}

	.close-button {
		display: flex;
		align-items: center;
		justify-content: center;
		block-size: 32px;
		inline-size: 32px;
		padding: 4px;
		border: none;
		border-radius: 4px;
		background: none;
		color: #666;
		font-size: 16px;
		cursor: pointer;
	}

	.close-button :global(*) {
		pointer-events: none;
	}

	.close-button:hover {
		background-color: #f5f5f5;
		color: #333;
	}

	.error-message-box {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		padding-block-start: 1rem;
		padding-inline: 1rem;
		border-radius: 0.5rem;
		gap: 0.75rem;
	}

	.error-message-text {
		display: flex;
		margin-block-start: 0;
		color: #1d354b;
		font-size: 16px;
		line-height: 2.5rem;
	}
</style>
